import Badge from './Badge';

export default function ScorePill({ score }) {
  const [bg, color] = score >= 70
    ? ['#D1FAE5', '#10B981']
    : score >= 50
      ? ['#FEF3C7', '#F59E0B']
      : ['#FEE2E2', '#EF4444'];

  return <Badge bg={bg} color={color}>{score}</Badge>;
}
